import { ElementRef } from '@angular/core';
// Components
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import { CUSTOMIZE_PAGES_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
// Services
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
const _c0 = a0 => ({ active: a0 });
function PeriodToggleComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "a", 4);
    i0.ɵɵlistener("click", function PeriodToggleComponent_div_2_Template_a_click_1_listener() { const periodOption_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updatePeriodicity(periodOption_r2)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const periodOption_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, ctx_r2.periodicity === periodOption_r2.value));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", periodOption_r2.label, " ");
} }
const PERIOD_OPTIONS = [
    { label: 'Quarterly', value: 'quarterly' },
    { label: 'Annual', value: 'annual' },
];
export class PeriodToggleComponent {
    constructor(eltRef, accountsService) {
        this.eltRef = eltRef;
        this.accountsService = accountsService;
        this.USER = window.USER;
        this.periodOptions = PERIOD_OPTIONS;
        this.periodicity = this.eltRef.nativeElement.getAttribute('periodicity');
        this.periodicityUserPreference = this.eltRef.nativeElement.getAttribute('periodicityUserPreference');
    }
    updatePeriodicity(tabOption) {
        if (tabOption.value !== this.periodicity) {
            if (this.USER.authenticated) {
                this.accountsService
                    .putUserPreferences({
                    [this.periodicityUserPreference]: tabOption.value,
                })
                    .subscribe(() => {
                    window.location.reload();
                });
            }
            else {
                this.featureNeededComponent.openModal(CUSTOMIZE_PAGES_FEATURE);
            }
        }
    }
}
PeriodToggleComponent.ɵfac = function PeriodToggleComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PeriodToggleComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.AccountsService)); };
PeriodToggleComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PeriodToggleComponent, selectors: [["ycn-period-toggle"]], viewQuery: function PeriodToggleComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededComponent = _t.first);
    } }, inputs: { periodicity: "periodicity", periodicityUserPreference: "periodicityUserPreference" }, standalone: false, decls: 4, vars: 1, consts: [[1, "panel-action"], [1, "nav", "nav-tabs"], ["class", "nav-item panel-padding", 4, "ngFor", "ngForOf"], [1, "nav-item", "panel-padding"], ["href", "javascript:void(0)", 1, "nav-link", 3, "click", "ngClass"]], template: function PeriodToggleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "ul", 1);
        i0.ɵɵtemplate(2, PeriodToggleComponent_div_2_Template, 3, 4, "div", 2);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(3, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.periodOptions);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i3.FeatureNeededComponent], encapsulation: 2 });
